import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { FileService, MainAppService, ApplicationMessagesService } from '@medappsware/shared';
import { environment } from '../environments/environment';

@Component({
    selector: 'app-root',
    imports: [RouterOutlet],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})

export class AppComponent {
  sideNav: boolean = false;
  title = 'CoreLab Diagnostics';
  constructor(private readonly mainAppService: MainAppService, private readonly fileService: FileService, private readonly applicationMessagesService: ApplicationMessagesService){
      this.mainAppService.setAPIURL(environment.apiURL);
      this.fileService.setFilesApiUrl(environment.filesApiUrl);
      this.mainAppService.setAuthURL(environment.authApiUrl);
      this.mainAppService.setFilesApiUrl(environment.filesApiUrl);
      
      // Warm the application-messages cache at startup so the first popup doesn't
      // wait on a network call. Fire-and-forget: load() subscribes internally and
      // returns immediately, so it never blocks bootstrap or any other call. It is
      // also idempotent, so the per-popup load() calls become no-ops once this lands.
      this.applicationMessagesService.load(environment.coreApiUrl);

      this.loadGoogleMaps();
      this.loadFontsCss();
  }

  loadGoogleMaps() {
    if(document.getElementById('googleMapsScript')) {
      return;
    }
    if (typeof window?.google?.maps !== 'undefined') {
      return;
    }

    const script = document.createElement('script');
    script.src = 'https://maps.googleapis.com/maps/api/js?key=' + environment.placesApiKey + '&libraries=places&language=en&callback=Function.prototype';
    script.id= 'googleMapsScript';
    console.log('Appending google maps script');
    document.head.appendChild(script);

  }

  loadFontsCss() {
    if(document.getElementById('fontsCssLoaded')) {
      return;
    }
    const rmf = document.createElement('link');
    rmf.rel = 'stylesheet';
    rmf.href = './assets/css/roboto-mono-fonts.min.css';
    document.head.appendChild(rmf);

    const rsf = document.createElement('link');
    rsf.rel = 'stylesheet';
    rsf.href = './assets/css/roboto-slab-fonts.min.css';
    document.head.appendChild(rsf);

    const cf = document.createElement('link');
    cf.rel = 'stylesheet';
    cf.href = './assets/css/courgette-fonts.min.css';
    document.head.appendChild(cf);

    const cpf = document.createElement('link');
    cpf.rel = 'stylesheet';
    cpf.href = './assets/css/courier-prime-fonts-min.css';
    document.head.appendChild(cpf);

    const of = document.createElement('link');
    of.rel = 'stylesheet';
    of.href = './assets/css/oswald-fonts.min.css';
    document.head.appendChild(of);

    const animateCss = document.createElement('link');
    animateCss.rel = 'stylesheet';
    animateCss.href = './assets/css/animate.min.css';
    document.head.appendChild(animateCss);

    const karla = document.createElement('link');
    karla.rel = 'stylesheet';
    karla.href = './assets/css/karla-fonts.min.css';
    karla.id = 'fontsCssLoaded';
    document.head.appendChild(karla);

    const lora = document.createElement('link');
    lora.rel = 'stylesheet';
    lora.href = './assets/css/lora-fonts.min.css';
    document.head.appendChild(lora);

    const inter = document.createElement('link');
    inter.rel = 'stylesheet';
    inter.href = './assets/css/inter-fonts.min.css';
    document.head.appendChild(inter);

    const univers = document.createElement('link');
    univers.rel = 'stylesheet';
    univers.href = './assets/css/univers-fonts.min.css';
    document.head.appendChild(univers);

    const cousine = document.createElement('link');
    cousine.rel = 'stylesheet';
    cousine.href = './assets/css/cousine-fonts.min.css';
    document.head.appendChild(cousine);

    const cinzel = document.createElement('link');
    cinzel.rel = 'stylesheet';
    cinzel.href = './assets/css/cinzel-fonts.min.css';
    document.head.appendChild(cinzel);
  }
}
